import { ScanTableData } from "../../models/tables";
import { RepositoryProjectBranch } from "../utils";


export class ScanRepository  extends RepositoryProjectBranch {
  apiUrl = '/api/v1/scans/';

  async getByFinding(findingId: number): Promise<ScanTableData[]> {
    const response = await fetch(this.apiUrl + "?finding_id=" + findingId);
    return response.status === 200 ? await response.json().then(data => data) as ScanTableData[]:[];
  }
}
